// eslint-disable-next-line import/no-extraneous-dependencies
import axios from "axios";

const URL_BASE = `${process.env.ROOT_API}/arquivoUsuario`;
export default class ArquivoUsuarioService{
	static async salvarNovoArquivo(idUsuario, form, idUsuarioResponsavel) {
		return axios.post(`${URL_BASE}/cadastrar/${idUsuario}?idUsuarioResponsavel=${idUsuarioResponsavel}`, form);
	}
	static async baixar(id) {
		return axios.get(`${URL_BASE}/baixar/${id}`);
	}
	static async deletar(id, idUsuarioResponsavel) {
		return axios.delete(`${URL_BASE}/deletar/${id}?idUsuarioResponsavel=${idUsuarioResponsavel}`);
	}
	static async atualizar(id, descricao, idUsuarioResponsavel) {
		return axios.put(`${URL_BASE}/atualizar/${id}?descricao=${descricao}&idUsuarioResponsavel=${idUsuarioResponsavel}`);
	}
	static async consultarArquivosPorUsuario(idUsuario, pagina, arquivosPorPagina) {
		return axios.get(`${URL_BASE}/consultar?idUsuario=${idUsuario}&pagina=${pagina}&arquivosPorPagina=${arquivosPorPagina}`);
	}
}



// WEBPACK FOOTER //
// ./src/service/ArquivoUsuarioService.js